import React, { forwardRef } from 'react'
import clsx from 'clsx'
import styles from '../form-controls.module.scss'
import PropTypes from 'prop-types'

const InputComponent = forwardRef(({ multiline, InputProps, ...rest }, ref) =>
  React.createElement(multiline ? 'textarea' : 'input', {
    ref,
    title: rest.value,
    className: clsx(styles['control'], InputProps.className || '', styles[`control_size_${rest.size}`], {
      [styles['control_startAdornment']]: !!InputProps.startAdornment,
      [styles['control_endAdornment']]: !!InputProps.endAdornment,
      [styles['control_withPrefix']]: !!rest.prefix,
    }),
    ...rest,
  }),
)

InputComponent.propTypes = {
  multiline: PropTypes.bool,
  InputProps: PropTypes.object,
}

InputComponent.displayName = 'InputComponent'

export default InputComponent